<script>
export default {
    name: "publish-reload-button",
    props: {
        disabled: Boolean,
    },
    computed: {
        tReload() {
            return Lang.langGet("Reload");
        }
    }
}
</script>

<template>
    <v-btn :disabled="disabled"
           class="btn btn-secondary"
           @click="$emit('click')">
        <v-icon left>
            far fa-arrows-rotate
        </v-icon>
        {{ tReload }}
    </v-btn>
</template>
